import React from "react";
import { func, bool, string, number, shape, array } from "prop-types";
// import Modal from "react-modal";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input,
  Col,
  Badge,
  Modal,
} from "reactstrap";
import { Formik } from "formik";
import swal from "sweetalert2";
import { handleError } from "@/util/errorHandler";
import permissions from "@/api/permissions";
import Select from "react-select";
import LoadingOverlay from "./LoadingOverlay";
import users from "@/api/users";

const marginRight = {
  marginRight: "8px",
};

const badge = {
  padding: "8px 8px",
  marginRight: "8px",
  marginTop: "8px",
};

const badgeAction = {
  cursor: "pointer",
};

class EditUserModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      roleIds:
        props.user && props.user.roles ? props.user.roles.map(r => r.id) : [],
      authorities:
        props.user && props.user.authorities ? props.user.authorities : [],
      login: "",
      firstName: "",
      lastName: "",

      roles: [],
      rolesOptions: [],
      authorityOptions: [],

      authorityToAdd: null,
      roleToAdd: null,
    };
  }

  baseState = {
    ...this.state,
  };

  componentDidMount() {
    this.getRoles();
    this.getAuthorities();
  }

  getRoles = async () => {
    const { data } = await permissions.getAllRoles();

    this.setState({
      roles: data,
      rolesOptions: data.map(p => ({
        value: p.id,
        label: p.name,
      })),
    });
  };

  getAuthorities = async () => {
    const data = await permissions.getAuthorities();

    this.setState({
      authorityOptions: data.map(p => ({
        value: p,
        label: p,
      })),
    });
  };

  reset = () => {
    this.setState(this.baseState);
  };

  beforeClose = () => {
    this.reset();
    this.props.onModalClose();
  };

  onSendUpdateRoleRequest = async ({ roleName }) => {
    try {
      await permissions.createRole(roleName);

      await swal(
        "Success!",
        `Role ${roleName} successfully created.`,
        "success",
      );
      this.beforeClose();
    } catch (err) {
      handleError(err);
    }
  };

  onSelectAuthority = ({ value }) => {
    if (value) {
      this.setState({
        authorityToAdd: value,
      });
    }
  };

  onAddAuthority = validateForm => {
    if (
      this.state.authorities.includes(this.state.authorityToAdd) ||
      !this.state.authorityToAdd
    ) {
      return;
    }

    this.setState(
      {
        authorities: [...this.state.authorities, this.state.authorityToAdd],
      },
      validateForm,
    );
  };

  onRemoveAuthority = (role, validateForm) => {
    this.setState(
      {
        authorities: this.state.authorities.filter(a => role !== a),
      },
      validateForm,
    );
  };

  onSelectRole = role => {
    if (role && this.state.authorityOptions.includes(role)) {
      this.setState({
        authorityToAdd: role.value,
        roleToAdd: null,
      });
    } else if (role) {
      this.setState({
        roleToAdd: role.value,
        authorityToAdd: null,
      });
    }
  };

  onAddRole = validateForm => {
    if (
      this.state.roleIds.includes(this.state.roleToAdd) ||
      !this.state.roleToAdd
    ) {
      return;
    }

    this.setState(
      {
        roleIds: [...this.state.roleIds, this.state.roleToAdd],
      },
      validateForm,
    );
  };

  onRemoveRole = role => {
    this.setState({
      roleIds: this.state.roleIds.filter(r => role !== r),
    });
  };

  saveChanges = async ({ userLogin, firstName, lastName, userEmail }) => {
    this.setState({ isLoading: true });
    try {
      if (this.props.user.id) {
        const { id } = this.props.user;

        await users.updateUser({
          id,
          login: userLogin,
          roleIds: this.state.roleIds,
          authorities: this.state.authorities,
          firstName,
          lastName,
          email: userEmail,
        });
      } else {
        await users.createUser({
          login: userLogin,
          firstName,
          lastName,
          email: userEmail,
          authorities: this.state.authorities,
          roleIds: this.state.roleIds,
        });
      }
      this.setState({ isLoading: false });
      this.beforeClose();
    } catch (error) {
      this.setState({ isLoading: false });
      handleError(error);
    }
  };

  validateFormik = ({ userLogin, firstName, lastName, userEmail }) => {
    const errors = {};

    if (!firstName) {
      errors.firstName = "Please enter user's first name";
    }

    if (!lastName) {
      errors.lastName = "Please enter user's last name";
    }

    if (!userLogin) {
      errors.userLogin = "Please enter user's login";
    }

    if (!userEmail) {
      errors.userEmail = "Please enter user's email";
    }

    if (
      userEmail &&
      userEmail.length &&
      !/^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        userEmail,
      )
    ) {
      errors.userEmail = "Incorrect email. Please provide correct bank email";
    }

    if (
      this.state.roleIds.length === 0 &&
      this.state.authorities.length === 0
    ) {
      errors.roles = "User should have at least one role";
    }

    return errors;
  };

  render() {
    return (
      <Modal isOpen={this.props.isOpen}>
        <Card>
          <CardHeader>
            <Button close onClick={this.beforeClose} />

            <span>{this.props.user.id ? "Edit user" : "New user"}</span>
          </CardHeader>
          <LoadingOverlay loading={this.state.isLoading} />
          <Formik
            initialValues={{
              firstName: this.props.user.firstName || "",
              lastName: this.props.user.lastName || "",
              userLogin: this.props.user.login || "",
              userEmail: this.props.user.email || "",
            }}
            validate={this.validateFormik}
            onChange={this.validateFormik}
            onSubmit={this.saveChanges}>
            {({
              values,
              handleSubmit,
              handleChange,
              handleBlur,
              validateForm,
              errors,
              setErrors,
            }) => (
              <Form onSubmit={handleSubmit}>
                {/* Hook to avoid incorrect autofill  */}
                <input
                  name="login"
                  style={{ position: "absolute", top: "-1000px" }}
                />

                <CardBody>
                  <FormGroup row>
                    <Label sm={3}>Login</Label>
                    <Col sm={9}>
                      <Input
                        type="text"
                        name="userLogin"
                        placeholder="Enter user's login"
                        invalid={Boolean(errors.userLogin)}
                        value={values.userLogin}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.userLogin && (
                        <FormFeedback className="text-alert">
                          {errors.userLogin}
                        </FormFeedback>
                      )}
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label sm={3}>First name</Label>
                    <Col sm={9}>
                      <Input
                        type="text"
                        name="firstName"
                        placeholder="Enter user's first name"
                        invalid={Boolean(errors.firstName)}
                        value={values.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.firstName && (
                        <FormFeedback className="text-alert">
                          {errors.firstName}
                        </FormFeedback>
                      )}
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label sm={3}>Last name</Label>
                    <Col sm={9}>
                      <Input
                        type="text"
                        name="lastName"
                        placeholder="Enter user's last name"
                        invalid={Boolean(errors.lastName)}
                        value={values.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.lastName && (
                        <FormFeedback className="text-alert">
                          {errors.lastName}
                        </FormFeedback>
                      )}
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label sm={3}>Email</Label>
                    <Col sm={9}>
                      <Input
                        type="text"
                        name="userEmail"
                        placeholder="Enter user's email"
                        invalid={Boolean(errors.userEmail)}
                        value={values.userEmail}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.userEmail && (
                        <FormFeedback className="text-alert">
                          {errors.userEmail}
                        </FormFeedback>
                      )}
                    </Col>
                  </FormGroup>

                  <FormGroup row>
                    <Label sm={3}>Roles</Label>
                    <Col sm={9}>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ flex: 4, marginRight: "8px" }}>
                          <Select
                            onChange={this.onSelectRole}
                            options={[
                              ...this.state.authorityOptions,
                              ...this.state.rolesOptions,
                            ]}
                          />
                        </div>
                        <Button
                          style={{ flex: 1 }}
                          onClick={() => {
                            this.onAddRole(validateForm);
                            this.onAddAuthority(validateForm);
                          }}>
                          Add
                        </Button>
                      </div>

                      {this.state.authorities &&
                        this.state.authorities.map(p => (
                          <Badge style={badge} color="light" key={p}>
                            <span>{p}</span>{" "}
                            <span
                              style={badgeAction}
                              onClick={() => {
                                this.onRemoveAuthority(p, validateForm);
                              }}>
                              <i className="fa fa-times" />
                            </span>
                          </Badge>
                        ))}

                      {this.state.roleIds &&
                        this.state.roleIds.map(p => (
                          <Badge style={badge} color="light" key={p}>
                            <span>
                              {this.state.rolesOptions.find(r => r.value === p)
                                ? this.state.rolesOptions.find(
                                    r => r.value === p,
                                  ).label
                                : ""}
                            </span>{" "}
                            <span
                              style={badgeAction}
                              onClick={() => {
                                this.onRemoveRole(p);
                              }}>
                              <i className="fa fa-times" />
                            </span>
                          </Badge>
                        ))}

                      {errors.roles && (
                        <FormFeedback
                          style={Boolean(errors.roles) && { display: "block" }}
                          className="text-alert">
                          {errors.roles}
                        </FormFeedback>
                      )}
                    </Col>
                  </FormGroup>
                </CardBody>
                <CardFooter>
                  <Button style={marginRight} onClick={this.beforeClose}>
                    Close
                  </Button>
                  <Button color="primary" type="submit">
                    {this.props.user.id ? "Save changes" : "Create user"}
                  </Button>
                </CardFooter>
              </Form>
            )}
          </Formik>
        </Card>
      </Modal>
    );
  }
}

EditUserModal.defaultProps = {
  user: {
    id: null,
    login: null,
    email: null,
    firstName: null,
    lastName: null,
    authorities: [],
    roles: [],
  },
};

EditUserModal.propTypes = {
  isOpen: bool.isRequired,
  onModalClose: func.isRequired,
  user: shape({
    id: number,
    login: string,
    email: string,
    firstName: string,
    lastName: string,
    authorities: array,
    roles: array,
  }),
};

export default EditUserModal;
